import {
  Address,
  ApiBankAccount,
  Country,
  DigiLaSource,
  KycInfo,
  PhoneNumberWithPhoneCountry,
  ProductApplicationStatus as MinorApplicationStatus,
  RequiredDomesticAddress,
  UiConfig,
  UserInfoResponse,
  VerifyAuthCodeRequest,
} from '../types'

export { ProductApplicationStatus as MinorApplicationStatus } from '../types'

export enum DigiLaFlow {
  Default = 'default',
}

export type DigiLaUiConfig = UiConfig<DigiLaFlow, DigiLaSource>

export interface DigiLaVerifyAuthCodeRequest extends VerifyAuthCodeRequest, DigiLaUiConfig {}

export interface DigiLaUserInfoResponse extends UserInfoResponse {
  emailAddress?: string
  phoneCountry?: string
  phoneCountryCode?: string
  countries: Country[]
  isKycRequired: boolean
  kycInfo: KycInfo
  hasNetbank: boolean
  address: Address
}

export type DigiLaGetMinorUserInfoRequest = {
  minorSsn: string
}

export type MinorApplicationParams = {
  createBankAccountParams?: CreateBankAccountParams
  createInvestmentPortfolioParams?: CreateInvestmentPortfolioParams
} & MinorAuthorizations

export type DigiLaMinorApplication = {
  status: MinorApplicationStatus
} & MinorApplicationParams

export interface DigiLaGetMinorUserInfoResponse extends Omit<UserInfoResponse, 'address'> {
  isKycRequired: boolean
  isHouseholdMember: boolean
  isEmployee: boolean
  hasNetbank: boolean
  bankAccounts: ApiBankAccount[]
  availableServices: MinorServiceType[]
  availableAuthorizations: AuthorizationType[]
  countries: Country[]
  kycInfo: KycInfo
  isGuardianAoHouseholdPrimaryMember: boolean
  isGuardianApplicationInitiator: boolean
  hasTwoGuardians: boolean
  pendingApplication: DigiLaMinorApplication | null
  address: RequiredDomesticAddress
}

export type AddMinorToHouseholdRequest = {
  orderScard: boolean
  consent: boolean
}

export interface MinorAuthorizations {
  authorizations?: {
    card?: boolean
    netbank?: boolean
  }
}

export interface CreateApplicationRequest extends MinorAuthorizations {
  createBankAccountParams?: CreateBankAccountParams
  createInvestmentPortfolioParams?: CreateInvestmentPortfolioParams
  secondGuardianPhoneNumber?: PhoneNumberWithPhoneCountry
}

export interface AcceptApplicationRequest {
  paymentLimitSecondGuardian?: number
}

export enum MinorServiceType {
  OpenBankAccount = 'openBankAccount',
  OpenInvestmentService = 'openInvestmentService',
}

export enum AuthorizationType {
  PaymentCard = 'cardPowerOfAttorney',
  NetbankCredentials = 'netbankPowerOfAttorney',
}

export enum BankAccountType {
  SAccount = 'bankAccount',
  SavingsAccount = 'savingsAccount',
}

export interface CreateBankAccountParams {
  bankAccountType: BankAccountType
  bankAccountDetails: CommonBankAccountDetails
}

export interface CreateInvestmentPortfolioParams {
  shouldUseCreatedBankAccount: boolean
  bankAccountIban: string | null
}

export interface CommonBankAccountDetails {
  shouldAddRightsForMinor: boolean
  shouldAttachToMinorsNetbank: boolean
  paymentLimitFirstGuardian?: number
  paymentLimitMinor?: number
  statementDeliveryMethod: BankAccountStatementDeliveryMethod
  statementDeliveryInterval?: BankAccountStatementDeliveryInterval
  guardianAccessRights: BankAccountAccessRights
}

export enum BankAccountStatementDeliveryMethod {
  Netbank = 'netbank',
  NetbankAndMail = 'netbankAndMail',
}

export enum BankAccountStatementDeliveryInterval {
  Montly = 'monthly',
  BiWeekly = 'biweekly',
  Weekly = 'weekly',
  Daily = 'daily',
}

export enum InvestmentServiceAccountType {
  SAccount = 'bankAccount',
  SavingsAccount = 'savingsAccount',
  CreatedAccount = 'createdAccount',
}

export enum BankAccountAccessRights {
  Wide = 'wideAccessRights',
  NormalUse = 'normalAccessRights',
}

export enum DigiLaParam {
  DigiliBaseUrl = 'DIGILI_BASE_URL',
}
